export const PROFILE_PHONE_PLACEHOLDER = '+1-XXX-XXX-XXXX'
